/** @flow */
import Helmet from 'react-helmet';
import QueryString from 'query-string';
import React, { Component } from 'react';
import styled, { withTheme } from 'styled-components';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import { bindActionCreators, compose } from 'redux';
import { Redirect } from 'react-router-dom';
import { openSnackbar } from 'common/modules/ui/actions/uiActions';
import LoadingSpinner from 'common/components/LoadingSpinner';
import { RegistrationWrapper, RegistrationCard, RegistrationSection, ButtonSubmit, Logo } from 'common/modules/registration/styles';
import UserProfileAPI from 'common/modules/userProfile/services/UserProfileAPI';
import { closeSession } from '../authentication/actions/sessionActions';
import { isAuthenticated } from '../authentication/selectors/sessionSelectors';
import { Metrics, Fonts } from '../../themes';

const styles = {
  header: {
    ...Fonts.style.sub,
    fontWeight: 'bold',
    textAlign: 'center',
  },
};

const ErrorMessage = styled.div`
  margin-bottom: ${Metrics.largeMargin}px;
`;

const SuccessMessage = styled.span`
  margin-bottom: ${Metrics.largeMargin}px
`;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 600px;
  margin: ${Metrics.margin}px 0;
`;

type Props = {
  isAuthenticated: boolean;
  t: any;
  theme: any;
  actions: {
    closeSession: () => mixed;
    openSnackbar: (type: string, message: string) => mixed,
  }
};

type State = {
  token: string;
  redirect: boolean;
  confirmEmailError: boolean;
  updating: boolean;
}

class ConfirmEmailPage extends Component<Props, State> {
  state = {
    token: '',
    updating: false,
    redirect: false,
    confirmEmailError: false,
  };

  constructor(props) {
    super(props);

    if (props.isAuthenticated) {
      props.actions.closeSession();
    }
    this.handleConfirmation();
  }

  handleConfirmation() {
    const queryParams = QueryString.parse(location.search);
    if (!queryParams || !queryParams.token) {
      this.redirect();
    } else {
      this.confirmEmail(queryParams.token);
    }
  }

  async confirmEmail(token: string) {
    try {
      await this.setState({ updating: true });

      await UserProfileAPI.confirmEmail(token);

      this.props.actions.openSnackbar('message', this.props.t('confirmEmailSuccess'));
    } catch (e) {
      this.setState({
        confirmEmailError: true,
      });
      this.props.actions.openSnackbar('error', this.props.t('confirmEmailError'));
    }

    this.setState({ updating: false });
  }

  redirect = () => {
    this.setState({
      redirect: true,
    });
  }

  render() {
    const {
      t, theme: { images: { logo, background } },
    } = this.props;
    const { updating } = this.state;

    return (
      <RegistrationWrapper background={background}>
        {this.state.redirect &&
          <Redirect to="/" />
        }
        <Helmet>
          <title>{t('confirmEmail')}</title>
        </Helmet>
        <RegistrationCard zDepth={5}>
          <RegistrationSection>
            <Logo src={logo} alt="logo" />

            <h2 style={styles.header}>{t('confirmEmail')}</h2>
            { updating &&
              <LoadingSpinner size="medium" />
            }
            { this.state.confirmEmailError &&
              <ContentWrapper>
                <ErrorMessage style={{ ...Fonts.style.midSmall, lineHeight: 1.5 }}>
                  {t('confirmEmailError')}
                </ErrorMessage>
                <ButtonSubmit onClick={this.redirect}>{t('goToHome')}</ButtonSubmit>
              </ContentWrapper>
            }
            { !updating && !this.state.confirmEmailError &&
              <ContentWrapper>
                <SuccessMessage>{t('confirmEmailSuccess')}</SuccessMessage>
                <ButtonSubmit onClick={this.redirect}>
                  {t('goToHome')}<i className="material-icons" style={{ verticalAlign: 'middle' }}>chevron_right</i>
                </ButtonSubmit>
              </ContentWrapper>
            }
          </RegistrationSection>
        </RegistrationCard>
      </RegistrationWrapper>
    );
  }
}

function mapStateToProps(state) {
  return {
    isAuthenticated: isAuthenticated(state),
  };
}

function mapDispatchToProps(dispatch: *) {
  return {
    actions: bindActionCreators({ closeSession, openSnackbar }, dispatch),
  };
}

export default compose(translate('userProfile'), connect(mapStateToProps, mapDispatchToProps), withTheme)(ConfirmEmailPage);



// WEBPACK FOOTER //
// ./src/advertisers/modules/userProfile/ConfirmEmailPage.js